import React from "react";
import styled from "styled-components";
import { Link } from "gatsby";

const Logo = props => {
  return (
    <StyledLogo 
      as={Link} 
      to="/"
      title="The Outlaw Ocean Project"
      tabIndex="0"
      activeClassName="is-active"
    ><span>The Outlaw Ocean Project</span></StyledLogo>
  );
};

export default Logo;

const StyledLogo = styled.a`
  position: relative;
  display: block;
  text-transform: uppercase;
  font-family: var(--font-heading);
  font-weight: 700;
  line-height: 1;
  letter-spacing: 0.05em;
  margin: 0 auto;
  background-color: var(--theme-background-light);
  color: var(--theme-text-against-light);
  padding: 0.25em 0.1875em 0.1em 0.25em;
  transition: opacity 0.2s ease;
  .can-hover &:hover,
  &:active {
    opacity: 0.7;
  }


  @media ( max-width: 60em ) {
    text-align: center;
    width: 100%;
    padding-right: 0;
    padding-left: 0;
    display: grid;
    justify-content: center;
    font-size: 5.3vw;
    box-shadow: 0.125em 0 0 var(--theme-background-light), -0.125em 0 0 var(--theme-background-light);
    margin-left: -1.5px;
    span {
      white-space: nowrap;
      padding-left: 1px;
    }
  }
  @media ( max-width: 48em ) {
    .has-left & {
      background-color: var(--theme-background-dark);
      color: var(--theme-text-against-dark);
      box-shadow: 0.125em 0 0 var(--theme-background-dark), -0.125em 0 0 var(--theme-background-dark);
    }
  }

  @media ( min-width: 48em ) {
    font-size: 1.375em;
  }
`;